enum InstitutionState {
    Enabled = "ENABLED",
    Disabled = "DISABLED"
}
export default InstitutionState